import { Box } from "@mui/material";
import NotAuthorized from "components/notAuthorized";
import useApi from "hooks/useApi";
import useBase from "hooks/useBase";
import usePermissions from "hooks/usePermissions";
import { useEffect, useState } from "react";
import ActivityHeader from "./ActivityHeader";
import Filter from "./Filter";
import MainTable from "./table/MainTable";

const ExpenseVsIncome = () => {
  const { base } = useBase();
  const { loading, fetchData } = useApi();
  const [expenseVsIncome, setExpenseVsIncome] = useState([]);
  const [reload, setReload] = useState(false);
  const [filters, setFilters] = useState({});
  const [search, setSearch] = useState();
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 30,
    to: 0,
    from: 0,
    total: 0,
  });

  useEffect(() => {
    let finalFilters = { ...filters };
    let finalPagination = { ...pagination };
    finalFilters.search = search;
    const getActivityList = async () => {
      const endpoint = {
        method: "post",
        url:
          "/api/admin/report/expense-vs-income?" +
          `page=${finalPagination?.current_page}&limit=${finalPagination?.per_page}`,
        data: finalFilters,
      };
      const result = await fetchData(endpoint, false);
      if (result?.success) {
        const { data, ...rest } = result?.data;
        setExpenseVsIncome(data);
        setPagination(rest);
      }
    };
    getActivityList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload, pagination?.current_page, pagination?.per_page, search]);

  const isFiltering = () => {
    let filtering = false;
    for (const key in filters) {
      if (Array.isArray(filters[key])) {
        if (filters[key].length > 0) filtering = true;
      } else {
        if (filters[key]) filtering = true;
      }
    }
    return filtering;
  };

  const permissions = usePermissions("report");

  return (
    <Box>
      <ActivityHeader
        {...{
          expenseVsIncome,
          setSearch,
          setPagination,
          pagination,
          setFilters,
          search,
          filters,
          isFiltering,
          permissions,
          ...base,
        }}
      />

      {!!permissions["University Target Report"] && (
        <Filter
          {...{
            setPagination,
            pagination,
            setFilters,
            filters,
            isFiltering,
            setReload,
            ...base,
          }}
        />
      )}
      {permissions["University Target Report"] ? (
        <MainTable
          expenseVsIncome={expenseVsIncome}
          pagination={pagination}
          setPagination={setPagination}
          loading={loading}
          setReload={setReload}
          permissions={permissions}
        />
      ) : (
        <NotAuthorized />
      )}
    </Box>
  );
};

export default ExpenseVsIncome;
